import $axios from "../../api";

const PREFIX = "website/member";

const state = () => ({
  isLoading: false,
  isErrors: "",
  page: 1,
  isSuccess: false,
  list: null,
  detail: null,
  isMinVip: null,
  marketList: null,
  productMarketList: null,
  loadMarket: true,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
  ASSIGN_IS_MIN_VIP(state, payload) {
    state.isMinVip = payload;
  },
  SET_LIST_MARKET(state, payload) {
    state.marketList = payload;
  },
  SET_LIST_PRODUCT_MARKET(state, payload) {
    state.productMarketList = payload;
  },
  SET_LOAD_MARKET(state, payload) {
    state.loadMarket = payload;
  },
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`)
        .then((res) => {
          commit("SET_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/view?id=${payload}`)
        .then((res) => {
          commit("SET_DETAIL", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  update({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/update`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  checkUp({ commit, state, rootState, dispatch }, payload) {
    commit("ASSIGN_IS_MIN_VIP", null);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/check-upgrade`, payload)
        .then((res) => {
          commit("ASSIGN_IS_MIN_VIP", res.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  upgradeToVIP({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/upgrade-member`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getDetailMarket({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/detail-market?member_id=${payload || ""}`)
        .then((res) => {
          commit("SET_LIST_MARKET", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getMarketProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOAD_MARKET", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/detail-market-product?page=${state.page}&member_id=${payload || ""}`)
        .then((res) => {
          commit("SET_LIST_PRODUCT_MARKET", res.data.data);
          commit("SET_LOAD_MARKET", false);
        })
        .catch((error) => {
          commit("SET_LOAD_MARKET", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
